import { combineReducers } from 'redux'
import apiKeysSlice from 'slices/apiKeysSlice'
import appResourceSlice from 'slices/appResourceSlice'
import authReducer from 'slices/authSlice'
import bulkLocationSlice from 'slices/bulkLocationSlice'
import chatSlice from 'slices/chatSlice'
import companySlice from 'slices/companySlice'
import demographicsSlice from 'slices/demographicsSlice'
import myPartnerAppSlice from 'slices/myPartnerAppSlice'
import partnerAppSlice from 'slices/partnerAppSlice'
import portfolioSlice from 'slices/portfolioSlice'
import fleetSlice from 'slices/fleetSlice'
import groupSlice from 'slices/groupSlice'
import portfolioNoteSlice from 'slices/portfolioNoteSlice'
import portfolioImageSlice from 'slices/portfolioImagesSlice'
import portfolioFinancialsSlice from 'slices/portfolioFinancialsSlice'
import portfolioTaskCNSlice from 'slices/portfolioTaskCNSlice'
import projectSlice from 'slices/projectSlice'
import projectImageSlice from 'slices/projectImagesSlice'
import documentLibrarySlice from 'slices/documentLibrarySlice'
import otherRetailerSlice from 'slices/otherRetailerSlice'
import usersReducer from 'slices/usersSlice'
import invitedUserReducer from 'slices/invitedUserSlice'
import invitedUserListSlice from 'slices/invitedUserListSlice'
import siteDetailsReducer from 'slices/siteDetailsSlice'
import taskCNSlice from 'slices/taskCNSlice'
import tasksReducer from 'slices/tasksSlice'
import myPartnersSlice from 'slices/myPartnersSlice'
import postSlice from 'slices/postSlice'
import locationsSlice from 'slices/locationSlice'
import lookupListSlice from 'slices/lookupListSlice'
import locationNoteSlice from 'slices/locationNoteSlice'
import locationImageSlice from 'slices/locationImageSlice'
import captureImageSlice from 'slices/captureImageSlice'
import templateSlice from 'slices/templateSlice'
import incomeStatementSlice from 'slices/incomeStatementSlice'
import onboardingSlice from 'slices/onboardingSlice'
import evaluationSlice from 'slices/evaluationSlice'
import evaluationSiteSlice from 'slices/evaluationSiteSlice'
import siteImageSlice from 'slices/siteImageSlice'
import siteNoteSlice from 'slices/siteNoteSlice'
import explorerSlice from 'slices/explorerSlice'
import presentationSlice from 'slices/presentationSlice'
import notificationSlice from 'slices/notificationSlice'
import scoringSlice from 'slices/scoringSlice'
import siteFinancialSlice from 'slices/siteFinancialSlice'
import riskSlice from 'slices/riskSlice'
import proConSlice from 'slices/proConSlice'
import approvalSlice from 'slices/approvalSlice'
import auditLogSlice from 'slices/auditLogSlice'
import reportSlice from 'slices/reportSlice'
import aiSlice from 'slices/aiSlice'

// import {
// 	// TODO - check this one last
// 	centerTenantsUploadReducer,
// } from '../redux/reducers/centerTenantReducers'

const appReducer = combineReducers({
	apiKey: apiKeysSlice.reducer,
	appResource: appResourceSlice.reducer,
	bulkLocations: bulkLocationSlice.reducer,
	chatHeaders: chatSlice.reducer,
	company: companySlice.reducer,
	userLogin: authReducer,
	demographics: demographicsSlice.reducer,
	fleets: fleetSlice.reducer,
	groups: groupSlice.reducer,
	invitedUser: invitedUserReducer,
	invitedUserList: invitedUserListSlice.reducer,
	locations: locationsSlice.reducer,
	lookupLists: lookupListSlice.reducer,
	captureImages: captureImageSlice,
	locationImages: locationImageSlice.reducer,
	locationNotes: locationNoteSlice.reducer,
	myPartnerApps: myPartnerAppSlice.reducer,
	myPartners: myPartnersSlice,
	partnerApps: partnerAppSlice.reducer,
	portfolios: portfolioSlice.reducer,
	portfolioFinancials: portfolioFinancialsSlice.reducer,
	portfolioTaskCN: portfolioTaskCNSlice.reducer,
	portfolioImages: portfolioImageSlice.reducer,
	portfolioNotes: portfolioNoteSlice.reducer,
	posts: postSlice.reducer,
	projects: projectSlice.reducer,
	projectImages: projectImageSlice.reducer,
	libraryDocuments: documentLibrarySlice.reducer,
	siteDetails: siteDetailsReducer,
	taskCNs: taskCNSlice.reducer,
	tasks: tasksReducer,
	templates: templateSlice.reducer,
	userList: usersReducer,
	incomeStatement: incomeStatementSlice,
	onboarding: onboardingSlice.reducer,
	evaluations: evaluationSlice.reducer,
	evaluationSites: evaluationSiteSlice.reducer,
	otherRetailers: otherRetailerSlice.reducer,
	siteImages: siteImageSlice.reducer,
	siteNotes: siteNoteSlice.reducer,
	explorer: explorerSlice.reducer,
	presentations: presentationSlice.reducer,
	notifications: notificationSlice.reducer,
	scoring: scoringSlice.reducer,
	siteFinancials: siteFinancialSlice.reducer,
	risks: riskSlice.reducer,
	proCons: proConSlice.reducer,
	approvals: approvalSlice.reducer,
	auditLog: auditLogSlice.reducer,
	reports: reportSlice.reducer,
	// Ask MDT (MYD-625). Reset on logout with everything else, so a shared
	// machine never shows the last user's conversation.
	ai: aiSlice.reducer,

	// // TODO - REMOVE EVERYTHING
	// centerTenantsUpload: centerTenantsUploadReducer,
	// // TODO - REMOVE EVERYTHING
})

const rootReducer = (state, action) => {
	if (action.type === 'auth/logout') {
		// Reset all slices to their initial state
		const resetState = appReducer(undefined, action)
		// Ensure auth state is fully cleared (initialState may have hydrated from localStorage)
		resetState.userLogin = {
			loading: false,
			isInitialized: false,
			userInfo: null,
			error: null,
		}
		return resetState
	}

	return appReducer(state, action)
}

export default rootReducer
